import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(['message-text-container'])
}
const _hoisted_2 = { class: "text" }

import {TUITranslateService} from "../../../../../../@aidesk/uikit-engine";


export default /*@__PURE__*/_defineComponent({
  __name: 'message-concurrency-limit',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(TUITranslateService).t('AIDesk.并发限制')), 1)
  ]))
}
}

})